import React from 'react';

import { Field } from 'formik';
import ItemWrapper from 'Components/Admin/Form/components/ItemWrapper/ItemWrapper';
import { SubFormContainer } from 'Components/Admin/Form';

const createFormikField = (Component) => {
  return ({ name, label, placeholder, subLabel, subForm, type, ...props }) => {
    const isSelected = (value) => !!(Array.isArray(value) ? value.length : value);
    const isError = (form) => form.touched[name] && form.errors[name];
    const isShowActionButtons = () => !['card'].includes(type);

    const renderComponent = (field, form) => (
      <Component
        fieldProps={{
          placeholder,
          ...field,
        }}
        helperVariant={isError(form) ? 'error' : undefined}
        error={isError(form)}
        {...props}
      />
    );

    return (
      <Field name={name}>
        {
          ({ field, form }) => {
            return (
              <ItemWrapper label={label} subLabel={subLabel} error={isError(form)}>
                {
                  subForm
                    ? (
                      <SubFormContainer
                        {...subForm}
                        name={name}
                        form={form}
                        isSelected={isSelected(field.value)}
                        isActionButtons={isShowActionButtons()}
                      >
                        {renderComponent(field, form)}
                      </SubFormContainer>
                    )
                    : renderComponent(field, form)
                }
              </ItemWrapper>
            );
          }
        }
      </Field>
    );
  };
};

export default createFormikField;
